module.exports = __webpack_public_path__ + "img/select_menu_bottom_bg.1f169113.png";